import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'

import { onCloseQuoteSavedSatisfactoryDialog } from '../QuoteStepOne/QuoteStepOne.actions'
import { CircleSuccessIcon, DialogWrapper, Row } from './QuoteSaveDraftDialog.styles'

import { topPage } from '../../modules/utils/topPage'
import { inIframe } from '../../modules/utils/inIframe'

/**
 * The QuoteSaveDraftDialog's container.
 */
const QuoteSaveDraftDialog = () => {
  const dispatch = useDispatch()
  const { openSaveDialog, quote } = useSelector(state => state.quoteStepOne)

  const isInIframe = useMemo(() => inIframe(), [])

  const handleCloseSatisfactoryDialog = () => dispatch(onCloseQuoteSavedSatisfactoryDialog())

  useEffect(() => topPage(isInIframe, openSaveDialog), [openSaveDialog])

  return (
    <Dialog disableBackdropClick open={openSaveDialog} verticalAlign="top" onClose={handleCloseSatisfactoryDialog}>
      <DialogWrapper>
        <CircleSuccessIcon fontSize="64px" />
        <Row>
          <Typography fontWeight="bold" variant="h4">
            El formulario ha sido guardado satisfactoriamente.
          </Typography>
          <Typography margin="16px 0 0" variant="body2">
            ID: {quote?.code}
          </Typography>
        </Row>
        <Row>
          <Button color="primary" onClick={handleCloseSatisfactoryDialog} variant="outlined">
            Aceptar
          </Button>
        </Row>
      </DialogWrapper>
    </Dialog>
  )
}

export default QuoteSaveDraftDialog
